import PropTypes from 'prop-types'
import React from 'react'

import UserGuestMenu from './user/guestMenuContainer'
import UserSignedInMenu from './user/signedInMenu'

class UserMenu extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    currentSite: PropTypes.string.isRequired
  }

  render () {
    const { user, currentSite } = this.props

    if (user && user.profile) {
      return <UserSignedInMenu user={user} currentSite={currentSite} />
    } else {
      return <UserGuestMenu />
    }
  }
}

export default UserMenu



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/userMenu.js